
<div class="row wccard p-3">

  <div class="w-100">
    <div class="row">
      <div class="col d-flex flex-column">
        <span class="f-14 font-weight-600" style="color: #484B59;">Tags</span>
        <span class="f-12 font-weight-400 mt-1" style="color: #484B59;">Create and use tags to label, organize, and quickly retrieve candidates.</span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <label class="mb-0 mt-3 f-14">Enter Tag Name</label>
        <input data-testid="auto-app-tag-management-input-1" [formControl]="tagInput" placeholder="Enter Tag Name" type="text" class="wc-form-control nobg mt-1">
        <span class="f-12 text-danger mt-1" *ngIf="tagInputError">Duplicate Tag</span>
        <span class="f-12 text-danger mt-1" *ngIf="tagInputSpecialCharError">Special Character Not Allowed</span>
      </div>

      <div class="col-md-3">
        <button data-testid="auto-app-tag-management-button-1" class="btn-trms-medium w-100" style="margin-top: 37px;" (click)="addTag()"
        [disabled]="showSpinnerLoader || tagInputSpecialCharError || tagInputError">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Save'}}
          </span>
        </button>
      </div>
    </div>
  </div>

</div>


<div class="row wccard p-3 mt-1">
  <span class="f-14 font-weight-600" style="color: #484B59;">All Tags</span>
</div>


<!-- For Tags Listing -->
<div class="row mt-1">

  <!-- If Tags Not Available -->
  <div *ngIf="allTags.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div class="text-center">
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No tags yet. Create one to get started.</p>
      </div>
    </div>
  </div>

  <!-- If Tags Available -->
  <div class="col" *ngIf="allTags.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">

      <div class="col-md-6">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Tag Name
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Last Updated
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>
    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngFor="let tag of allTags">
      <div class="col-md-6">
        <div class="d-flex align-items-center">
          <div (click)="editTag(tag)" class="d-flex justify-content-center align-items-center icon"
            style=" border: none; border-radius: 50% !important;">
            <i class="fa-solid fa-tag"></i>
          </div>
          <span class="f-14 font-weight-400 ml-1" style="color: #484B59;">{{tag?.tagtext}}</span>
        </div>
      </div>

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">{{tag?.updatedon | date: 'dd MMM yyyy'}}</span>
      </div>

      <div class="col">
        <div class="d-flex">
          <div (click)="openModel(tag, 'edit')" class="d-flex justify-content-center align-items-center icon" matTooltip="Edit" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-pen-to-square"></i>
          </div>

          <div (click)="openModel(tag, 'delete')" class="d-flex justify-content-center align-items-center icon" matTooltip="Delete" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-trash"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<!-- For Edit Tag model -->
<ng-template #tagEditModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Edit {{tagDetails?.tagtext}} Tag</span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <label class="f-14 ">Enter Tag Name</label>
      <input data-testid="auto-app-tag-management-input-2" [formControl]="editTagInput" placeholder="Enter Tag Name" type="text" class="wc-form-control nobg">
      <span class="f-12 text-danger mt-1" *ngIf="editTagInputError">Duplicate Tag</span>
      <span class="f-12 text-danger mt-1" *ngIf="editInputSpecialCharError">Special Character Not Allowed</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-tag-management-button-2" class="btn-trms-white mr-3" [ngClass]="{ 'text-center': showActionSpinnerLoader }" (click)="editTag()"
          [disabled]="showActionSpinnerLoader || editInputSpecialCharError || editTagInputError">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showActionSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showActionSpinnerLoader }">
            {{showActionSpinnerLoader ? '' : 'YES'}}
          </span>
        </button>
        <button data-testid="auto-app-tag-management-button-3" class="btn-trms-small" (click)="dismiss()">NO</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For Delete Tag model -->
<ng-template #tagDeleteModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Delete Tag {{tagDetails?.tagtext}} ?</span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <span class="f-14 font-weight-400 mt-3" style="color: #484B59;">
      The tag <b>{{tagDetails?.tagtext}}</b> is currently attached to <b>{{tagDetails?.tagedcandidatecount}} candidate {{tagDetails?.tagedcandidatecount > 1 ? "'s" : ""}}</b>.
      Are you sure you want to delete it? This action cannot be undone.
    </span>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-tag-management-button-4" class="btn-trms-white mr-3" [ngClass]="{ 'text-center': showActionSpinnerLoader }" (click)="deleteTag()"
          [disabled]="showActionSpinnerLoader">
          <span [ngClass]="{ 'spinner-border text-blue spinner-size': showActionSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showActionSpinnerLoader }">
            {{showActionSpinnerLoader ? '' : 'YES'}}
          </span>
        </button>
        <button data-testid="auto-app-tag-management-button-5" class="btn-trms-small" (click)="dismiss()">NO</button>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>